<template>
  <div class="modal fade" role="dialog">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <button id="close" class="close" data-dismiss="modal">&times;</button>
          <center>
            <h3 class="modal-title">{{ $t('message.login') }}</h3>
          </center>
        </div>
        <div class="modal-body">
          <div v-if="isError" class="alert alert-danger" role="alert">{{ errormsg }}</div>
          <form @submit.prevent>
            <fieldset>
              <div class="form-group">
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 modal-text">
                  <input v-model="loginForm.UserName" :placeholder="$t('message.username')" type="text" class="form-control">
                </div>
              </div>
              <div class="form-group">
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 modal-text">
                  <input v-model="loginForm.Password" :placeholder="$t('message.password')" type="password" class="form-control">
                </div>
              </div>
              <!-- 验证码 -->
              <!-- <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" style="display: flex; align-items: center;">
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6" style="padding: 0;">
                  <img :src="captcha" style="cursor: pointer;" @click="handleClickCaptcha">
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6" style="padding: 0;">
                  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" style="padding: 0;">
                    <input v-model="loginForm.captchaText" :placeholder="$t('message.captcha')" type="password" class="form-control">
                  </div>
                </div>
              </div> -->
              <div class="form-group">
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" style="margin-top: 10px;">
                  <div>
                    <span>
                      <input v-model="remember" type="checkbox">
                      <span>{{ $t('message.remeberme') }}</span>
                    </span>
                  </div>
                </div>
              </div>
            </fieldset>
          </form>
        </div>
        <div class="modal-footer">
          <a class="btn btn-danger f-white pull-left btn-sm" href="javascript:;" data-dismiss="modal" @click="handleForgetPwd">
            {{ $t('message.forgetpwd') }}
          </a>
          <a class="btn btn-info f-white pull-left btn-sm" href="javascript:;" data-dismiss="modal" @click="handleRegister">
            {{ $t('message.register') }}
          </a>
          <button type="button" class="btn btn-sm btn-login" @click.prevent="handleLogin">
            {{ $t('message.login') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import $ from 'jquery'
import { mapGetters } from 'vuex'
import commonmix from '@/utils/commonmix'
import { getFirstWarn, setFirstWarn } from '@/utils'
import { setLocalStore, getLocalStore } from '@/utils/common'

export default {
  mixins: [commonmix],
  data() {
    return {
      errormsg: '',
      loginForm: {},
      logined: false,
      isError: false,
      remember: false,
      captcha: null,
      timer: null
    }
  },
  computed: {
    ...mapGetters([
      'name',
      'token',
      'userow'
    ])
  },
  // mounted() {
  //   $('#loginModel').on('show.bs.modal', (e) => {
  //     this.getCaptcha()
  //   })
  // },
  updated() {
    // 回车登录
    document.onkeyup = (e) => {
      if (e.keyCode === 13 && (!this.logined && (!getLocalStore().username && !getLocalStore().password))) {
        this.handleLogin()
      }
    }
  },
  methods: {
    // handleClickCaptcha() {
    //   clearTimeout(this.timer)
    //   this.timer = setTimeout(() => {
    //     this.getCaptcha()
    //   }, 500)
    // },
    // getCaptcha() {
    //   const reader = new FileReader()
    //   this.$store.dispatch('GetCaptchaImage').then((res) => {
    //     reader.readAsDataURL(res)
    //   })
    //   reader.onload = () => {
    //     this.captcha = reader.result
    //   }
    // },
    handleLogin() {
      // 登录
      this.$store.dispatch('Login', this.loginForm).then(() => {
        this.$store.dispatch('GetUserProfile', this.loginForm.UserName).then(() => {
          this.logined = true
          this.isError = false
          // 续费提醒
          if ((!this.isEN && this.userow.ChargeState === 3) || (this.isEN && this.userow.ChargeStataEn === 3)) {
            const expiretime = this.isEN ? this.userow.ChargeEnExpireDate : this.userow.ChargeExpireDate
            const isFirstWarn = getFirstWarn(this.name, expiretime)
            if (isFirstWarn) {
              setFirstWarn(this.name, expiretime)
              this.openRenewalModal()
            }
            // 过期提醒
            if (new Date(expiretime) < new Date()) {
              this.openRenewalModal()
            }
          }
          // 登录成功保存Token
          if (this.remember) {
            setLocalStore({ token: this.token })
          }
          this.closeLoginModal()
        })
        this.$store.dispatch('UpdateUserActivityByToken', this.token)
      }).catch((err) => {
        this.isError = true
        if (err.ErrorCode === 6009) {
          this.errormsg = this.$t('message.userpwdnotmatch')
        }
      })
    },
    // 注册
    handleRegister() {
      $('.modal-backdrop').remove()
      const path = this.isEN ? '/english/signup' : 'signup'
      this.$router.push(path)
    },
    // 忘记密码
    handleForgetPwd() {
      $('.modal-backdrop').remove()
      const path = this.isEN ? '/english/forget_passwd' : 'forget_passwd'
      this.$router.push(path)
    }
  }
}
</script>
<style scoped>
.modal { margin-top: 15%; }
.modal-dialog { max-width: 500px; }
.modal-title { font-size: 23px; font-weight: lighter; }
.modal-body { padding: 15px 0; }
.modal-text { padding-bottom: 20px; }
.f-white:link { color: #fff; }
.f-white:visited { color: #fff; }
.f-white:hover { color: #fff; }
.f-white:active { color: #fff; }
.main-box { width:650px; display: block; margin-right: auto; margin-left: auto; margin-top:40px; }
.checkbox-style { margin:0; vertical-align:middle; margin-right: 5px; }
.login-title { font-size: 23px; font-weight: 300; border-bottom: 1px solid #eee; }
.btn-login { color: #fff; background-color: #4b8df8; }
</style>



// WEBPACK FOOTER //
// src/components/LoginDialog/index.vue